var exports = {
  "WB": "GroupDMWelcomeSection.module__welcomeSection___UFpObF",
  "rZ": "GroupDMWelcomeSection.module__profileSection___UFpObF",
  "hv": "GroupDMWelcomeSection.module__groupName___UFpObF",
  "Yh": "GroupDMWelcomeSection.module__welcomeText___UFpObF",
  "o1": "GroupDMWelcomeSection.module__actions___UFpObF",
};

module.exports = exports;
